import gql from 'graphql-tag'

export const NOTIFY_ADD_FAVORITE = gql`
  mutation NotifyAddFavorite($productErpIdentifier: String!) {
    notifyAddFavorite(productErpIdentifier: $productErpIdentifier)
  }
`
